import React from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import DonationRequestEdit from '../../../Donation/DonationManage/DonationRequestEdit/DonationRequestEdit';

const FoodDonorMobileRequestEdit = () => {
  const history = useHistory();
  const match = useRouteMatch();

  return <DonationRequestEdit isMobileView history={history} match={match} />;
};

export default FoodDonorMobileRequestEdit;
